import Animation from './Animation';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import useIsSlideOpen from '../../mobileAppCore/components/MobileSliderPages/hooks/useIsSlideOpen';
import { AnimationFullScreenWrapperStyled } from './styled/AnimationStyled';
import { useMakeSelector } from '../../hooks/useMakeSelector';
import { makeSelectShownAnimationsOnEventByName } from './animationSelectors';
import { ANIMATION_EVENT_NAMES } from './animationConstants';
import { animationSlice } from './animationReducer';

function FirstStartAnimation() {
    const isShowWelcomeAnimation = useMakeSelector(makeSelectShownAnimationsOnEventByName, [ANIMATION_EVENT_NAMES.FIRST_START]);
    const isSlideOpen = useIsSlideOpen();
    const [showAnimation, setShowAnimation] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        if (isShowWelcomeAnimation && !isSlideOpen) {
            setShowAnimation(true);
            dispatch(animationSlice.actions.setIsShowAnimationOnEventAction({
                eventName: ANIMATION_EVENT_NAMES.FIRST_START,
                isShow: false,
            }));
        }
    }, [dispatch, isShowWelcomeAnimation, isSlideOpen]);

    if (!showAnimation) {
        return null;
    }

    return <AnimationFullScreenWrapperStyled>
        <Animation
            name={'ConfettiWelcome'}
            rendererSettings={{ preserveAspectRatio: 'xMidYMid slice' }}
            loop={false}
            renderer={'canvas'}
            style={{ width: '100%', height: '100%' }}
        />
    </AnimationFullScreenWrapperStyled>;
}

export default FirstStartAnimation;
